import EmptyRouter from '@/layout/EmptyRouter.vue';
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';
export default {
  path: 'workorder',
  name: 'BusinessWorkorder',
  component: EmptyRouterAlive,
  meta: {
    title: '工单管理',
  },
  children: [
    /**     ****** 工单管理    ******** */
    {
      path: 'workorderType',
      name: 'BusinessWorkorderType',
      component: EmptyRouter,
      redirect: 'workorderType/index',
      meta: { title: '工单类型管理', isCache: true },
      children: [
        {
          path: 'index',
          name: 'BusinessWorkorderType',
          component: () => import('@/views/center-business/workorder/workorderType'),
          meta: { title: '工单类型管理', isCache: true },
        },
      ],
    },
    {
        path: 'workorderList',
        name: 'BusinessOpenWorkorderList',
        component: EmptyRouter,
        redirect: 'workorderList/open',
        meta: { title: '未完成工单', isCache: true },
        children: [
          {
            path: 'open',
            name: 'BusinessOpenWorkorderList',
            component: () => import('@/views/center-business/workorder/openWorkorder'),
            meta: { title: '未完成工单', isCache: true },
          },
          {
            path: 'submit',
            name: 'BusinessWorkorderListForm',
            component: () => import('@/views/center-business/workorder/components/workOrderForm'),
            meta: { title: '提交工单', isCache: true },
          },
        ],
      },
      {
        path: 'workorderList',
        name: 'BusinessCloseWorkorderList',
        component: EmptyRouter,
        redirect: 'workorderList/close',
        meta: { title: '已完成工单', isCache: true },
        children: [
          {
            path: 'close',
            name: 'BusinessCloseWorkorderList',
            component: () => import('@/views/center-business/workorder/closeWorkorder'),
            meta: { title: '已完成工单', isCache: true },
          },
          {
            path: 'submit',
            name: 'BusinessWorkorderListForm',
            component: () => import('@/views/center-business/workorder/components/workOrderForm'),
            meta: { title: '提交工单', isCache: true },
          },
        ],
      },
  ],
};
